import React, { Component, Fragment } from "react";
import { statsService } from "services";

import { defaultChartHeight, defaultChartHeightRaw, sortFunction, label } from "utils/charts";
import { Spin, Icon, Tooltip } from "antd";
import "../../../node_modules/react-vis/dist/style.css";

// Gestionnaire de Chart pour la page dashboard.
// Traitement pour afficher le bon graph (en fonction de /src/constants/charts.js),
// fetch des données et refresh lorsque nécéssaire.
// Props.infos correspond au paramètres propres à ce Chart (type, titre, icone, etc.)
class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      loading: true,
      refreshes: 0,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  // Handle le changement des filtres.
  // On se base sur props.refreshes (qui provient de la page Dashboard)
  // pour savoir si on doit update le graphique. Si props.refreshes est différent
  // de state.refreshes, on sait que les filtres ont changés.
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.refreshes === prevState.refreshes) return null;

    return {
      loading: true,
    };
  }

  // Fetch les datas si on est en chargement (donc en attente de data).
  componentDidUpdate(prevProps, prevState) {
    if (this.state.loading === true) this.fetchData();
  }

  // Fetch et sort les datas en fonction des filtres.
  async fetchData(props = this.props) {
    const { filters, infos, refreshes } = props;

    try {
      let data;

      const formatter = (unformatted) => {
        if (Array.isArray(unformatted)) {
          unformatted.map((d) => {
            d.label = label(d.label);
          });

          if (!("sort" in props) || props.sort !== false)
            unformatted.sort((a, b) => {
              sortFunction(a, b, "label");
            });
        }
        return unformatted;
      };
      if (infos.data) {
        data = infos.data;
      } else if (infos.fetchData) {
        data = await infos.fetchData(filters);
        data = formatter(data);
      } else {
        data = [];
        const multiple = Array.isArray(infos.url) || infos.multiSeries;
        const urls = Array.isArray(infos.url) ? infos.url : [infos.url];

        infos.props = {
          ...infos.props,
          dataCount: urls.length,
          multiple,
        };

        for (const url of urls) {
          const d = await statsService.get(url, filters);
          data.push(formatter(d));
        }

        if (!multiple) data = data[0];
      }

      this.setState({ data, loading: false, refreshes: refreshes });
    } catch (e) {
      this.setState({ data: [], loading: false, refreshes: refreshes });
    }
  }

  // Le compte de refreshes est passé au graphique en soit, pour qu'il puisse se mettre à jour
  // sans avoir à faire de la comparaison d'objets.
  render() {
    const { infos, filters } = this.props;
    const { loading, refreshes } = this.state;
    const data = infos.transformData ? infos.transformData(this.state.data) : this.state.data;

    if (infos.transformLabels) {
      infos.props.labels = infos.transformLabels(this.state.data);
    }

    // Lorsque mentionné dans les paramètres, certains graphiques
    // ne doivent pas s'afficher quand certains filtres sont sélectionnés.
    if (infos.excludedByFilters) {
      var hide = false;
      infos.excludedByFilters.forEach((ex) => {
        if (ex in filters && filters[ex].length !== 0) {
          hide = true;
          return;
        }
      });

      if (hide) return <></>;
    }

    // Setup du nom de la classe (+ gestion de la width relative du graph).
    const className =
      "graph-item " +
      (infos.classes ? `${infos.classes} ` : "") +
      (infos.width ? `col-${infos.width} ` : "col-4");

    // Affichage du "fallback" -- si aucune data pour ce Chart.
    if (!loading && (typeof data === "undefined" || data.length === 0)) {
      return (
        <div className={className + " unavailable-graph"}>
          <h2>
            {infos.icon && <Icon type={infos.icon} />}
            <span>{infos.title}</span>
          </h2>
          <div className="error">
            <Icon type="stop" />
            <h3>Aucune donnée pour ce graphique</h3>
            <p>Veuillez tenter de changer les filtres sélectionnés.</p>
          </div>
        </div>
      );
    }

    // Loading du composant pour afficher le graphique approprié.
    const ChartType = infos.component;
    if (!ChartType) return <></>;

    // Affichage du graphique.
    return (
      <div className={className}>
        <Spin spinning={loading}>
          {/* Titre du chart */}
          {(infos.icon || infos.title || infos.legend) && (
            <h2>
              {infos.icon && <Icon type={infos.icon} />}
              <span className="chart-title">{infos.title}</span>
              {infos.legend && (
                <Tooltip title={infos.legend} arrowPointAtCenter>
                  <Icon>help</Icon>
                </Tooltip>
              )}
            </h2>
          )}

          {/* Content du chart */}
          <div
            style={
              infos.maxHeight
                ? { maxHeight: infos.maxHeight }
                : { height: infos.height ? infos.height : defaultChartHeight }
            }
            className="apply-overflow-here"
          >
            <ChartType
              data={data}
              refreshes={refreshes}
              height={infos.height ? infos.height : defaultChartHeightRaw}
              {...infos.props}
            />
          </div>
        </Spin>
      </div>
    );
  }
}

export default Chart;
